import { Card, CardContent, Grid, Snackbar } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { setTask } from '../../store/actions/taskActions';
import Yorum from './Comment';
import Knowledge from './KnowledgeBase';
import Digiport from './Digiport';
import Alert from 'src/components/Alert';


const useStyles = makeStyles(() => ({
  root: {},
  content: {
    minHeight: 430
  },
  submitButtonFile: {
    width: '100%'
  }
}));

function TechnicalSupport({ className, ReceiptNo, readonly, setOpenSnackbar, setResponseDsc, setResponseType, tasks, setTask }) {
  const classes = useStyles();
  const { t } = useTranslation('work_order');


  return (
    <Card className={clsx(classes.root, className)}>
      <CardContent className={classes.content}>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={4} lg={4}>
          <Yorum ReceiptNo={ReceiptNo} readonly={false} setOpenSnackbar={setOpenSnackbar} setResponseDsc={setResponseDsc} setResponseType={setResponseType} />
         
          </Grid>
          <Grid item xs={12} sm={4} lg={4}>
            <Digiport ReceiptNo={ReceiptNo} />
          </Grid>
          <Grid item xs={12} sm={4} lg={4}>
          <Knowledge ReceiptNo={ReceiptNo} readonly={false} setOpenSnackbar={setOpenSnackbar} setResponseDsc={setResponseDsc} setResponseType={setResponseType} />
          </Grid>
        </Grid>
      </CardContent>
      
    </Card>

  );
}

TechnicalSupport.propTypes = {
  className: PropTypes.string
};

export default connect(
  state => ({
    tasks: state.tasks1
  }),
  { setTask }
)(TechnicalSupport);
